import { render, staticRenderFns } from "./ReportLadyicats.vue?vue&type=template&id=b6ed71d6&"
import script from "./ReportLadyicats.vue?vue&type=script&lang=js&"
export * from "./ReportLadyicats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports